<template>
    <div>
        <v-row>
            <v-col cols="12" lg="12">
                <app-card hide-header>

                    <div class="pa-3">
                        <v-alert color="#33D3FF" variant="tonal" elevation="0" style="border: 1px solid #33D3FF;">
                            <div style="display: flex; align-items: flex-start;">
                                <v-icon color="#0891B2" class="mr-2" style="flex-shrink: 0; margin-top: 2px;">mdi-information-outline</v-icon>
                                <span style="color: black">Invoicing has moved out of the Sway portal.<br />This page is no longer updated. You will receive future invoices by email.<br />For billing questions, contact
                                <a href="mailto:accounting@healthyroster.com" style="color: #0891B2">accounting@healthyroster.com</a>.</span>
                            </div>
                        </v-alert>
                    </div>

                    <div v-if="invoices && invoices.length > 0">
                        <app-data-table
                            :items="invoices"
                            :headers="invoicesTableHeaders"
                            :loading="loadingInvoices"
                            @onRowClick="onRowClick"
                        >
                            <template #item.paidTotal="{item}">

                                <div v-if="item.payment && !item.isRefunded">
                                    {{ item.paidTotal }}
                                    <app-chip  color="green" label small class="ml-2">Paid</app-chip>
                                </div>
                                <div v-else-if="item.isRefunded">
                                    <app-chip  color="yellow" label small class="ml-2">Payment Refunded</app-chip>
                                </div>
                                <div v-else-if="item.deletedOn">
                                    <app-chip  color="gray" label small class="ml-2">VOIDED</app-chip>
                                </div>
                                <div v-else>
                                    <app-chip :color="item.isPastDue ? 'red' : 'blue'" label small>{{ item.isPastDue ? 'Past Due' : 'Outstanding' }}</app-chip>
                                </div>

                            </template>
                        </app-data-table>
                    </div>
                    <div v-else class="pa-4">
                        <span>There are no invoices in the portal.</span>
                    </div>

                </app-card>
            </v-col>
        </v-row>
        
        <router-view v-slot="{ Component }">
            <component
                :is="Component"
                :currentInvoice="currentInvoice"
                :billingInfo="billingInfo"
            />
        </router-view>  
    </div>
</template>

<script>

export default {
    name: "BillingHistory",
    props: {
        billingInfo: {
            type: Object,
            required: true,
        },
        invoices: {
            required: true
        }
    },
    data() {
        return {
            // invoices: [],
            loadingInvoices: false,
            currentInvoice: null,
            // invoiceHeaders: [
            //     {
            //         text: 'Description',
            //         value: 'name'
            //     },
            //     {
            //         text: 'Detail',
            //         value: 'description'
            //     },
            //     {
            //         text: 'Quantity',
            //         value: 'quantity'
            //     },
            //     {
            //         text: 'Amount',
            //         value: 'subTotal'
            //     },
            // ],
            invoicesTableHeaders: [
                {
                    text: 'Invoice Number',
                    value: 'displayNumber'
                },
                {
                    text: 'Invoice Date',
                    value: 'issuedOn'
                },
                {
                    text: 'Due Date',
                    value: 'displayDueDate'
                },
                {
                    text: 'Total',
                    value: 'total'
                },
                {
                    text: 'Payment',
                    value: 'paidTotal'
                },
            ],
            
        }
    },
    mounted() {
        // this.getInvoices();
    },
    computed: {
        
    },
    methods: {
        
        onRowClick(item) {
            this.currentInvoice = item;
            this.$router.push({ path: '/billing/view-invoices', query: { orgId: this.billingInfo.organizationId, id: item.id }});
        }
    }
}
</script>

<style scoped>

</style>